import styled, {css} from 'styled-components';
import PropTypes from 'prop-types';

export const Column = styled.div`
  flex: ${props => props.grow ? 1 : 0} ${props => props.shrink ? 1 : 0} ${props => props.percentage}%;
  margin-top: 0;
  margin-right: ${props => props.noMargin ? `${props.offsetRightPercentage}%` : `calc(8px + ${props.offsetRightPercentage}%)`};
  margin-bottom: 0;
  margin-left: ${props => props.noMargin ? `${props.offsetPercentage}%` : `calc(8px + ${props.offsetPercentage}%)`};
  &:first-child {
    margin-left: ${props => props.offsetPercentage}%;
  }
  &:last-child {
    margin-right: ${props => props.offsetRightPercentage}%;
  }

  @media (max-width: 768px) {
    ${props => props.hideOnMobile ? css`
      display: none;  
    ` : ''};
    ${props => !props.keepGrid ? css`
      margin-top: 0;
      margin-right: 0;
      margin-left: 0;
      padding-bottom: 20px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
        margin-bottom: 0;
      }
    ` : ''};
  }
`;

Column.propTypes = {
    percentage: PropTypes.number,
    shrink: PropTypes.bool,
    grow: PropTypes.bool,
    hideOnMobile: PropTypes.bool,
    keepGrid: PropTypes.bool,
    noMargin: PropTypes.bool,
    offsetPercentage: PropTypes.number,
    offsetRightPercentage: PropTypes.number
};

Column.defaultProps = {
    shrink: true,
    grow: true,
    keepGrid: false,
    offsetPercentage: 0,
    offsetRightPercentage: 0
};
